const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
export default capitalize



// WEBPACK FOOTER //
// ./src/capitalize.js